<script>
import axios from "axios";
//import { VueRecaptcha } from 'vue-recaptcha';
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import { required, email, sameAs, minValue, maxValue } from "vuelidate/lib/validators";

/**
 * Register component
 */
export default {
  page: {
    title: "Register",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Multiselect,
    //VueRecaptcha,
  },
  data() {
    return {
      user: {
        companyName: "",
        email: "",
        country: {
          text: '',
          value: '',
          list: [],
        },
        timezone: "",
        selTimezone: null,
        total: '',
        password: "",
        confirmPassword: "",
      },
      submitted: false,
      apiHit: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      countryOptions: [
        { text: "Andorra", value: "Europe/Andorra"},
        { text: "United Arab Emirates", value: "Asia/Dubai"},
        { text: "Afghanistan", value: "Asia/Kabul"},
        { text: "Antigua and Barbuda", value: "America/Antigua"},
        { text: "Anguilla", value: "America/Anguilla"},
        { text: "Albania", value: "Europe/Tirane"},
        { text: "Armenia", value: "Asia/Yerevan"},
        { text: "Netherlands Antilles", value: "Europe/Amsterdam"},
        { text: "Angola", value: "Africa/Luanda"},
        { text: "Antarctica", value: "Antarctica/Casey"},
        { text: "Argentina", value: "America/Argentina/Buenos_Aires", list: [
                {text: "America/Argentina/Buenos_Aires", value: "UTC -03:53"},
                {text: "America/Argentina/Catamarca", value: "UTC -04:23"},
                {text: "America/Argentina/Cordoba", value: "UTC -04:16"},
                {text: "America/Argentina/Jujuy", value: "UTC -04:21"},
                {text: "America/Argentina/La_Rioja", value: "UTC -04:27"},
                {text: "America/Argentina/Mendoza", value: "UTC -04:35"},
                {text: "America/Argentina/Rio_Gallegos", value: "UTC -04:36"},
                {text: "America/Argentina/Salta", value: "UTC -04:21"},
                {text: "America/Argentina/San_Juan", value: "UTC -04:34"},
                {text: "America/Argentina/San_Luis", value: "UTC -04:25"},
                {text: "America/Argentina/Tucuman", value: "UTC -04:20"},
                {text: "America/Argentina/Ushuaia,", value: "UTC -04:33"}
                ]
        },
        { text: "American Samoa", value: "Pacific/Pago_Pago"},
        { text: "Austria", value: "Europe/Vienna"},
        { text: "Australia", value: "Australia/Sydney", list: [
                {
                        text: "Antarctica/Macquarie",
                        value: "UTC"
                },
                {
                        text: "Australia/Adelaide",
                        value: "UTC +09:14"
                },
                {
                        text: "Australia/Brisbane",
                        value: "UTC +10:12"
                },
                {
                        text: "Australia/Broken_Hill",
                        value: "UTC +09:25"
                },
                {
                        text: "Australia/Darwin",
                        value: "UTC +08:43"
                },
                {
                        text: "Australia/Eucla",
                        value: "UTC +08:35"
                },
                {
                        text: "Australia/Hobart",
                        value: "UTC +09:49"
                },
                {
                        text: "Australia/Lindeman",
                        value: "UTC +09:55"
                },
                {
                        text: "Australia/Lord_Howe",
                        value: "UTC +10:36"
                },
                {
                        text: "Australia/Melbourne",
                        value: "UTC +09:39"
                },
                {
                        text: "Australia/Perth",
                        value: "UTC +07:43"
                },
                {
                        text: "Australia/Sydney",
                        value: "UTC +10:04"
                }
                ]},
        { text: "Aruba", value: "America/Aruba"},
        { text: "Åland Islands", value: "Europe/Mariehamn"},
        { text: "Azerbaijan", value: "Asia/Baku"},
        { text: "Bosnia and Herzegovina", value: "Europe/Sarajevo"},
        { text: "Barbados", value: "America/Barbados"},
        { text: "Bangladesh", value: "Asia/Dhaka"},
        { text: "Belgium", value: "Europe/Brussels"},
        { text: "Burkina Faso", value: "Africa/Ouagadougou"},
        { text: "Bulgaria", value: "Europe/Sofia"},
        { text: "Bahrain", value: "Asia/Bahrain"},
        { text: "Burundi", value: "Africa/Bujumbura"},
        { text: "Benin", value: "Africa/Porto-Novo"},
        { text: "Saint Barthélemy", value: "America/St_Barthelemy"},
        { text: "Bermuda", value: "Atlantic/Bermuda"},
        { text: "Brunei", value: "Asia/Brunei"},
        { text: "Bolivia", value: "America/La_Paz"},
        { text: "Bonaire, Sint Eustatius and Saba", value: "America/Kralendijk" },
        { text: "Brazil", value: "America/Araguaina", list: 
                [
                {text: "America/Araguaina", value: "UTC -03:12"},
                {text: "America/Bahia", value: "UTC -02:34"},
                {text: "America/Belem", value: "UTC -03:13"},
                {text: "America/Boa_Vista", value: "UTC -04:02"},
                {text: "America/Campo_Grande", value: "UTC -03:38"},
                {text: "America/Cuiaba", value: "UTC -03:44"},
                {text: "America/Eirunepe", value: "UTC -04:39"},
                {text: "America/Fortaleza", value: "UTC -02:34"},
                {text: "America/Maceio", value: "UTC -02:22"},
                {text: "America/Manaus", value: "UTC -04:00"},
                {text: "America/Noronha", value: "UTC -02:09"},
                {text: "America/Porto_Velho", value: "UTC -04:15"},
                {text: "America/Recife", value: "UTC -02:19"},
                {text: "America/Rio_Branco", value: "UTC -04:31"},
                {text: "America/Santarem", value: "UTC -03:38"},
                {text: "America/Sao_Paulo", value: "UTC -03:06"}]},
        { text: "Bahamas", value: "America/Nassau"},
        { text: "Bhutan", value: "Asia/Thimphu"},
        { text: "Bouvet Island", value: "null"},
        { text: "Botswana", value: "Africa/Gaborone"},
        { text: "Belarus", value: "Europe/Minsk"},
        { text: "Belize", value: "America/Belize"},
        { text: "Canada", value: "America/Atikokan", list: 
                [{text: "America/Atikokan", value: "UTC -05:18"},
                {text: "America/Blanc-Sablon", value: "UTC -04:24"},
                {text: "America/Cambridge_Bay", value: "UTC"},
                {text: "America/Creston", value: "UTC -07:28"},
                {text: "America/Dawson", value: "UTC -09:17"},
                {text: "America/Dawson_Creek", value: "UTC -08:00"},
                {text: "America/Edmonton", value: "UTC -07:33"},
                {text: "America/Fort_Nelson", value: "UTC -08:10"},
                {text: "America/Glace_Bay", value: "UTC -03:59"},
                {text: "America/Goose_Bay", value: "UTC -04:01"},
                {text: "America/Halifax", value: "UTC -04:14"},
                {text: "America/Inuvik", value: "UTC"},
                {text: "America/Iqaluit", value: "UTC"},
                {text: "America/Moncton", value: "UTC -04:19"},
                {text: "America/Nipigon", value: "UTC -05:53"},
                {text: "America/Pangnirtung", value: "UTC"},
                {text: "America/Rainy_River", value: "UTC -06:18"},
                {text: "America/Rankin_Inlet", value: "UTC"},
                {text: "America/Regina", value: "UTC -06:58"},
                {text: "America/Resolute", value: "UTC"},
                {text: "America/St_Johns", value: "UTC -03:30"},
                {text: "America/Swift_Current", value: "UTC -07:11"},
                {text: "America/Thunder_Bay", value: "UTC -05:57"},
                {text: "America/Toronto", value: "UTC -05:17"},
                {text: "America/Vancouver", value: "UTC -08:12"},
                {text: "America/Whitehorse", value: "UTC -09:00"},
                {text: "America/Winnipeg", value: "UTC -06:28"},
                {text: "America/Yellowknife", value: "UTC"}]},
        { text: "Cocos Islands", value: "Indian/Cocos"},
        { text: "The Democratic Republic Of Congo", value: "Africa/Kinshasa", list:
                [
                {text: "Africa/Kinshasa", value: "UTC +00:13"},
                {text: "Africa/Lubumbashi", value: "UTC +02:10"}
                ]},
        { text: "Central African Republic", value: "Africa/Bangui"},
        { text: "Congo", value: "Africa/Kinshasa"},
        { text: "Switzerland", value: "Europe/Zurich"},
        { text: "Côte d'Ivoire", value: "Africa/Abidjan"},
        { text: "Cook Islands", value: "Pacific/Rarotonga"},
        { text: "Chile", value: "America/Punta_Arenas", list:
                [
                {text: "America/Punta_Arenas", value: "UTC -04:43"},
                {text: "America/Santiago", value: "UTC -04:42"},
                {text: "Pacific/Easter", value: "UTC -07:17"},
                ]},
        { text: "Cameroon", value: "Africa/Douala"},
        { text: "China", value: "Asia/Shanghai", list:
                [
                {text: "Asia/Shanghai", value: "UTC +08:05"},
                {text: "Asia/Urumqi", value: "UTC +05:50"}
                ]},
        { text: "Colombia", value: "America/Bogota"},
        { text: "Costa Rica", value: "America/Costa_Rica"},
        { text: "Cuba", value: "America/Havana"},
        { text: "Cape Verde", value: "Atlantic/Cape_Verde"},
        { text: "Curaçao", value: "America/Curacao"},
        { text: "Christmas Island", value: "Indian/Christmas"},
        { text: "Cyprus", value: "Asia/Famagusta", list:
                [
                {text: "Asia/Famagusta", value: "UTC +02:15"},
                {text: "Asia/Nicosia", value: "UTC +02:13"}
                ]},
        { text: "Czech Republic", value: "Europe/Prague"},
        { text: "Germany", value: "Europe/Copenhagen"},
        { text: "Djibouti", value: "Africa/Djibouti"},
        { text: "Denmark", value: "Europe/Copenhagen"},
        { text: "Dominica", value: "America/Dominica"},
        { text: "Dominican Republic", value: "America/Santo_Domingo"},
        { text: "Algeria", value: "Africa/Algiers"},
        { text: "Ecuador", value: "America/Guayaquil", list:
                [
                {text: "America/Guayaquil", value: "UTC -05:19"},
                {text: "Pacific/Galapagos", value: "UTC -05:58"}
                ]},
        { text: "Estonia", value: "Europe/Tallinn"},
        { text: "Egypt", value: "Africa/Cairo"},
        { text: "Western Sahara", value: "Africa/El_Aaiun"},
        { text: "Eritrea", value: "Africa/Asmara"},
        { text: "Spain", value: "Europe/Madrid", list:
                [
                {text: "Africa/Ceuta", value: "UTC -00:21"},
                {text: "Atlantic/Canary", value: "UTC -01:01"},
                {text: "Europe/Madrid", value: "UTC -00:14"},
                ]},
        { text: "Ethiopia", value: "Africa/Addis_Ababa"},
        { text: "Finland", value: "Europe/Helsinki"},
        { text: "Fiji", value: "Pacific/Fiji"},
        { text: "Falkland Islands", value: "Atlantic/Stanley"},
        { text: "Micronesia", value: "Pacific/Chuuk", list:
                [
                {text: "Pacific/Chuuk", value: "UTC -13:52"},
                {text: "Pacific/Kosrae", value: "UTC -13:08"},
                {text: "Pacific/Pohnpei", value: "UTC -13:27"},
                ]},
        { text: "Faroe Islands", value: "Atlantic/Faroe"},
        { text: "France", value: "Europe/Paris"},
        { text: "Gabon", value: "Africa/Libreville"},
        { text: "United Kingdom", value: "Europe/London"},
        { text: "Grenada", value: "America/Grenada"},
        { text: "Georgia", value: "Asia/Tbilisi"},
        { text: "French Guiana", value: "America/Cayenne"},
        { text: "Guernsey", value: "Europe/Guernsey"},
        { text: "Ghana", value: "Africa/Accra"},
        { text: "Gibraltar", value: "Europe/Gibraltar"},
        { text: "Greenland", value: "America/Danmarkshavn", list:
                [
                {text: "America/Danmarkshavn", value: "UTC -01:14"},
                {text: "America/Nuuk", value: "UTC -03:26"},
                {text: "America/Scoresbysund", value: "UTC -01:27"},
                {text: "America/Thule", value: "UTC -04:35"},
                ]},
        { text: "Gambia", value: "Africa/Banjul"},
        { text: "Guinea", value: "Africa/Conakry"},
        { text: "Guadeloupe", value: "America/Guadeloupe"},
        { text: "Equatorial Guinea", value: "Africa/Malabo"},
        { text: "Greece", value: "Europe/Athens"},
        { text: "South Georgia And The South Sandwich Islands", value: "Atlantic/South_Georgia"},
        { text: "Guatemala", value: "America/Guatemala"},
        { text: "Guam", value: "Pacific/Guam"},
        { text: "Guinea-Bissau", value: "Africa/Bissau"},
        { text: "Guyana", value: "America/Guyana"},
        { text: "Hong Kong", value: "Asia/Hong_Kong"},
        { text: "Heard Island And McDonald Islands", value: "No/Timezone"},
        { text: "Honduras", value: "America/Tegucigalpa"},
        { text: "Croatia", value: "Europe/Zagreb"},
        { text: "Haiti", value: "America/Port-au-Prince"},
        { text: "Hungary", value: "Europe/Budapest"},
        { text: "Indonesia", value: "Asia/Jakarta", list:
                [
                {text: "Asia/Jakarta", value: "UTC +07:07"},
                {text: "Asia/Jayapura", value: "UTC +09:22"},
                {text: "Asia/Makassar", value: "UTC +07:57"},
                {text: "Asia/Pontianak", value: "UTC +07:17"},
                ]},
        { text: "Ireland", value: "Europe/Dublin"},
        { text: "Israel", value: "Asia/Jerusalem"},
        { text: "Isle Of Man", value: "Europe/Isle_of_Man"},
        { text: "India", value: "Asia/Kolkata"},
        { text: "British Indian Ocean Territory", value: "Indian/Chagos"},
        { text: "Iraq", value: "Asia/Baghdad"},
        { text: "Iran", value: "Asia/Tehran"},
        { text: "Iceland", value: "Atlantic/Reykjavik"},
        { text: "Italy", value: "Europe/Rome"},
        { text: "Jersey", value: "Europe/Jersey"},
        { text: "Jamaica", value: "America/Jamaica"},
        { text: "Jordan", value: "Asia/Amman"},
        { text: "Japan", value: "Asia/Tokyo"},
        { text: "Kenya", value: "Africa/Nairobi"},
        { text: "Kyrgyzstan", value: "Asia/Bishkek"},
        { text: "Cambodia", value: "Asia/Phnom_Penh"},
        { text: "Kiribati", value: "Pacific/Kanton", list:
                [
                {text: "Pacific/Kanton", value: "UTC"},
                {text: "Pacific/Kiritimati", value: "UTC -10:29"},
                {text: "Pacific/Tarawa", value: "UTC +11:32"},
                ]},
        { text: "Comoros", value: "Indian/Comoro"},
        { text: "Saint Kitts And Nevis", value: "America/St_Kitts"},
        { text: "North Korea", value: "Asia/Pyongyang"},
        { text: "South Korea", value: "Asia/Seoul"},
        { text: "Kuwait", value: "Asia/Kuwait"},
        { text: "Cayman Islands", value: "America/Cayman"},
        { text: "Kazakhstan", value: "Asia/Almaty", list:
                [
                {text: "Asia/Almaty", value: "UTC +05:07"},
                {text: "Asia/Aqtau", value: "UTC +03:21"},
                {text: "Asia/Aqtobe", value: "UTC +03:48"},
                {text: "Asia/Atyrau", value: "UTC +03:27"},
                {text: "Asia/Oral", value: "UTC +03:25"},
                {text: "Asia/Qostanay", value: "UTC +04:14"},
                {text: "Asia/Qyzylorda", value: "UTC +04:21"},
                ]},
        { text: "Laos", value: "Asia/Vientiane"},
        { text: "Lebanon", value: "Asia/Beirut"},
        { text: "Saint Lucia", value: "America/St_Lucia"},
        { text: "Liechtenstein", value: "Europe/Vaduz"},
        { text: "Sri Lanka", value: "Asia/Colombo"},
        { text: "Liberia", value: "Africa/Monrovia"},
        { text: "Lesotho", value: "Africa/Maseru"},
        { text: "Lithuania", value: "Europe/Vilnius"},
        { text: "Luxembourg", value: "Europe/Luxembourg"},
        { text: "Latvia", value: "Europe/Riga"},
        { text: "Libya", value: "Africa/Tripoli"},
        { text: "Morocco", value: "Africa/Casablanca"},
        { text: "Monaco", value: "Europe/Monaco"},
        { text: "Moldova", value: "Europe/Chisinau"},
        { text: "Montenegro", value: "Europe/Podgorica"},
        { text: "Saint Martin", value: "America/Marigot"},
        { text: "Madagascar", value: "Indian/Antananarivo"},
        { text: "Marshall Islands", value: "Pacific/Kwajalein", list:
                [
                {text: "Pacific/Kwajalein", value: "UTC +11:09"},
                {text: "Pacific/Majuro", value: "UTC +11:24"},
                ]},
        { text: "Macedonia", value: "Europe/Skopje"},
        { text: "Mali", value: "Africa/Bamako"},
        { text: "Myanmar", value: "Asia/Yangon"},
        { text: "Mongolia", value: "Asia/Ulaanbaatar", list:
                [
                {text: "Asia/Choibalsan", value: "UTC +07:38"},
                {text: "Asia/Hovd", value: "UTC +06:06"},
                {text: "Asia/Ulaanbaatar", value: "UTC +07:07"},
                ]},
        { text: "Macao", value: "Asia/Macau"},
        { text: "Northern Mariana Islands", value: "Pacific/Saipan"},
        { text: "Martinique", value: "America/Martinique"},
        { text: "Mauritania", value: "Africa/Nouakchott"},
        { text: "Montserrat", value: "America/Montserrat"},
        { text: "Malta", value: "Europe/Malta"},
        { text: "Mauritius", value: "Indian/Mauritius"},
        { text: "Maldives", value: "Indian/Maldives"},
        { text: "Malawi", value: "Africa/Blantyre"},
        { text: "Mexico", value: "America/Mexico_City", list:
                [
                {text: "America/Bahia_Banderas", value: "UTC -07:01"},
                {text: "America/Cancun", value: "UTC -05:47"},
                {text: "America/Chihuahua", value: "UTC -07:04"},
                {text: "America/Hermosillo", value: "UTC -07:23"},
                {text: "America/Matamoros", value: "UTC -06:40"},
                {text: "America/Mazatlan", value: "UTC -07:05"},
                {text: "America/Merida", value: "UTC -05:58"},
                {text: "America/Mexico_City", value: "UTC -06:36"},
                {text: "America/Monterrey", value: "UTC -06:41"},
                {text: "America/Ojinaga", value: "UTC -06:57"},
                {text: "America/Tijuana", value: "UTC -07:48"},
                ]},
        { text: "Malaysia", value: "Asia/Kuala_Lumpur", list:
                [
                {text: "Asia/Kuala_Lumpur", value: "UTC +06:46"},
                {text: "Asia/Kuching", value: "UTC +07:21"},
                ]},
        { text: "Mozambique", value: "Africa/Maputo"},
        { text: "Namibia", value: "Africa/Windhoek"},
        { text: "New Caledonia", value: "Pacific/Noumea"},
        { text: "Niger", value: "Africa/Niamey"},
        { text: "Norfolk Island", value: "Pacific/Norfolk"},
        { text: "Nigeria", value: "Africa/Lagos"},
        { text: "Nicaragua", value: "America/Managua"},
        { text: "Netherlands", value: "Europe/Amsterdam"},
        { text: "Norway", value: "AEurope/Oslo"},
        { text: "Nepal", value: "Asia/Kathmandu"},
        { text: "Nauru", value: "Pacific/Nauru"},
        { text: "Niue", value: "Pacific/Niue"},
        { text: "New Zealand", value: "Pacific/Auckland", list:
                [
                {text: "Pacific/Auckland", value: "UTC +11:39"},
                {text: "Pacific/Chatham", value: "UTC +12:13"},
                ]},
        { text: "Oman", value: "Asia/Muscat"},
        { text: "Panama", value: "America/Panama"},
        { text: "Peru", value: "America/Lima"},
        { text: "French Polynesia", value: "Pacific/Gambier", list:
                [
                {text: "Pacific/Gambier", value: "UTC -08:59"},
                {text: "Pacific/Marquesas", value: "UTC -09:18"},
                {text: "Pacific/Tahiti", value: "UTC -09:58"},
                ]},
        { text: "Papua New Guinea", value: "Pacific/Bougainville", list:
                [
                {text: "Pacific/Bougainville", value: "UTC +10:22"},
                {text: "Pacific/Port_Moresby", value: "UTC +09:48"},
                ]},
        { text: "Philippines", value: "Asia/Manila"},
        { text: "Pakistan", value: "Asia/Karachi"},
        { text: "Poland", value: "Europe/Warsaw"},
        { text: "Saint Pierre And Miquelon", value: "America/Miquelon"},
        { text: "Pitcairn", value: "Pacific/Pitcairn"},
        { text: "Puerto Rico", value: "America/Puerto_Rico"},
        { text: "Palestine", value: "Asia/Gaza", list:
                [
                {text: "Asia/Gaza", value: "UTC +02:17"},
                {text: "Asia/Hebron", value: "UTC +02:20"},
                ]},
        { text: "Portugal", value: "Europe/Lisbon", list:
                [
                {text: "Atlantic/Azores", value: "UTC -01:42"},
                {text: "Atlantic/Madeira", value: "UTC -01:07"},
                {text: "Europe/Lisbon", value: "UTC -00:36"},
                ]},
        { text: "Palau", value: "Pacific/Palau"},
        { text: "Paraguay", value: "America/Asuncion"},
        { text: "Qatar", value: "Asia/Qatar"},
        { text: "Reunion", value: "Indian/Reunion"},
        { text: "Romania", value: "Europe/Bucharest"},
        { text: "Serbia", value: "Europe/Belgrade"},
        { text: "Russia", value: "Europe/Moscow", list:
                [
                {text: "Asia/Anadyr", value: "UTC +11:49"},
                {text: "Asia/Barnaul", value: "UTC +05:35"},
                {text: "Asia/Chita", value: "UTC +07:33"},
                {text: "Asia/Irkutsk", value: "UTC +06:57"},
                {text: "Asia/Kamchatka", value: "UTC +10:34"},
                {text: "Asia/Khandyga", value: "UTC +09:02"},
                {text: "Asia/Krasnoyarsk", value: "UTC +06:11"},
                {text: "Asia/Magadan", value: "UTC +10:03"},
                {text: "Asia/Novokuznetsk", value: "UTC +05:48"},
                {text: "Asia/Novosibirsk", value: "UTC +05:31"},
                {text: "Asia/Omsk", value: "UTC +04:53"},
                {text: "Asia/Sakhalin", value: "UTC +09:30"},
                {text: "Asia/Srednekolymsk", value: "UTC +10:14"},
                {text: "Asia/Tomsk", value: "UTC +05:39"},
                {text: "Asia/Ust-Nera", value: "UTC +09:32"},
                {text: "Asia/Vladivostok", value: "UTC +08:47"},
                {text: "Asia/Yakutsk", value: "UTC +08:38"},
                {text: "Asia/Yekaterinburg", value: "UTC +04:02"},
                {text: "Europe/Astrakhan", value: "UTC +03:12"},
                {text: "Europe/Kaliningrad", value: "UTC +01:22"},
                {text: "Europe/Kirov", value: "UTC +03:18"},
                {text: "Europe/Moscow", value: "UTC +02:30"},
                {text: "Europe/Samara", value: "UTC +03:20"},
                {text: "Europe/Saratov", value: "UTC +03:04"},
                {text: "Europe/Ulyanovsk", value: "UTC +03:13"},
                {text: "Europe/Volgograd", value: "UTC +02:57"},
                ]},
        { text: "Rwanda", value: "Africa/Kigali"},
        { text: "Saudi Arabia", value: "Asia/Riyadh"},
        { text: "Solomon Islands", value: "Pacific/Guadalcanal"},
        { text: "Seychelles", value: "Indian/Mahe"},
        { text: "Sudan", value: "Africa/Khartoum"},
        { text: "Sweden", value: "Europe/Stockholm"},
        { text: "Singapore", value: "Asia/Singapore"},
        { text: "Saint Helena", value: "Atlantic/St_Helena"},
        { text: "Slovenia", value: "Europe/Ljubljana"},
        { text: "Svalbard And Jan Mayen", value: "Arctic/Longyearbyen"},
        { text: "Slovakia", value: "Europe/Bratislava"},
        { text: "Sierra Leone", value: "Africa/Freetown"},
        { text: "San Marino", value: "Europe/San_Marino"},
        { text: "Senegal", value: "Africa/Dakar"},
        { text: "Somalia", value: "Africa/Mogadishu"},
        { text: "Suriname", value: "America/Paramaribo"},
        { text: "South Sudan", value: "Africa/Juba"},
        { text: "Sao Tome And Principe", value: "Africa/Sao_Tome"},
        { text: "El Salvador", value: "America/El_Salvador"},
        { text: "Sint Maarten (Dutch part)", value: "America/Lower_Princes"},
        { text: "Syria", value: "Asia/Damascus"},
        { text: "Swaziland", value: "Africa/Mbabane"},
        { text: "Turks And Caicos Islands", value: "America/Grand_Turk"},
        { text: "Chad", value: "Africa/Ndjamena"},
        { text: "French Southern Territories", value: "Indian/Kerguelen"},
        { text: "Togo", value: "Africa/Lome"},
        { text: "Thailand", value: "Asia/Bangkok"},
        { text: "Tajikistan", value: "Asia/Dushanbe"},
        { text: "Tokelau", value: "Pacific/Fakaofo"},
        { text: "Timor-Leste", value: "Asia/Dili"},
        { text: "Turkmenistan", value: "Asia/Ashgabat"},
        { text: "Tunisia", value: "Africa/Tunis"},
        { text: "Tonga", value: "Pacific/Tongatapu"},
        { text: "Turkey", value: "Europe/Istanbul"},
        { text: "Trinidad and Tobago", value: "America/Port_of_Spain"},
        { text: "Tuvalu", value: "Pacific/Funafuti"},
        { text: "Taiwan", value: "Asia/Taipei"},
        { text: "Tanzania", value: "Africa/Dar_es_Salaam"},
        { text: "Ukraine", value: "Europe/Kiev"},
        { text: "Uganda", value: "Africa/Kampala"},
        { text: "United States Minor Outlying Islands", value: "Pacific/Midway", list:
                [
                {text: "Pacific/Midway", value: "UTC +12:37"},
                {text: "Pacific/Wake", value: "UTC +11:06"},
                ]},
        { text: "United States", value: "America/New_York", list:
                [
                {text: "America/Adak", value: "UTC +12:13"},
                {text: "America/Anchorage", value: "UTC +14:00"},
                {text: "America/Boise", value: "UTC -07:44"},
                {text: "America/Chicago", value: "UTC -05:50"},
                {text: "America/Denver", value: "UTC -06:59"},
                {text: "America/Detroit", value: "UTC -05:32"},
                {text: "America/Indiana/Indianapolis", value: "UTC -05:44"},
                {text: "America/Indiana/Knox", value: "UTC -05:46"},
                {text: "America/Indiana/Marengo", value: "UTC -05:45"},
                {text: "America/Indiana/Petersburg", value: "UTC -05:49"},
                {text: "America/Indiana/Tell_City", value: "UTC -05:47"},
                {text: "America/Indiana/Vevay", value: "UTC -05:40"},
                {text: "America/Indiana/Vincennes", value: "UTC -05:50"},
                {text: "America/Indiana/Winamac", value: "UTC -05:46"},
                {text: "America/Juneau", value: "UTC +15:02"},
                {text: "America/Kentucky/Louisville", value: "UTC -05:43"},
                {text: "America/Kentucky/Monticello", value: "UTC -05:39"},
                {text: "America/Los_Angeles", value: "UTC -07:52"},
                {text: "America/Menominee", value: "UTC -05:50"},
                {text: "America/Metlakatla", value: "UTC +15:13"},
                {text: "America/New_York", value: "UTC -04:56"},
                {text: "America/Nome", value: "UTC +12:58"},
                {text: "America/North_Dakota/Beulah", value: "UTC -06:47"},
                {text: "America/North_Dakota/Center", value: "UTC -06:45"},
                {text: "America/North_Dakota/New_Salem", value: "UTC -06:45"},
                {text: "America/Phoenix", value: "UTC -07:28"},
                {text: "America/Sitka", value: "UTC +14:58"},
                {text: "America/Yakutat", value: "UTC +14:41"},
                {text: "Pacific/Honolulu", value: "UTC -10:31"},
                ]},
        { text: "Uruguay", value: "America/Montevideo"},
        { text: "Uzbekistan", value: "Asia/Tashkent", list:
                [
                {text: "Asia/Tashkent", value: "UTC +04:27"},
                {text: "Asia/Samarkand", value: "UTC +04:37"},
                ]},
        { text: "Vatican", value: "Europe/Vatican"},
        { text: "Saint Vincent And The Grenadines", value: "America/St_Vincent"},
        { text: "Venezuela", value: "America/Caracas"},
        { text: "British Virgin Islands", value: "America/Tortola"},
        { text: "U.S. Virgin Islands", value: "America/St_Thomas"},
        { text: "Vietnam", value: "Asia/Taipei"},
        { text: "Vanuatu", value: "Pacific/Efate"},
        { text: "Wallis And Futuna", value: "Pacific/Wallis"},
        { text: "Samoa", value: "Pacific/Apia"},
        { text: "Yemen", value: "Asia/Aden"},
        { text: "Mayotte", value: "Indian/Mayotte"},
        { text: "South Africa", value: "Africa/Johannesburg"},
        { text: "Zambia", value: "Africa/Lusaka"},
        { text: "Zimbabwe", value: "Africa/Harare"},
      ],
    };
  },
  validations: {
    user: {
      companyName: {
        required,
      },
      email: {
        required,
        email,
      },
      country: {
        required,
      },
      selTimezone: {
        required,
      },
      password: {
        required,
      },
      total: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(99999),
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
      },
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    verified(){
      alert("verified");
    },
    errorverified(){
      alert("errorverified");
    },
    // Try to register the user in with the email, companyName
    // and password they provided.
    onSelect() {
      let c = {};
      console.log(this.user.country);
      if(this.user.country.list && this.user.country.list.length > 0) {
        c = null;
      } else {
        c.text = "Asia/Kolkata";
        c.value = 'UTC +5.30';
      }
      this.user.selTimezone = c;
    },
    nameWithLang({ text }) {
      return `${text}`;
    },
    nameWithLangAndValue({ text, value }) {
      return `${text}  ( ${value} )`;
    },
    tryToRegisterIn() {
      this.submitted = true;
      this.apiHit = true;
      // stop here if form is invalid
      this.$v.$touch();


      if (this.$v.$invalid) {
        this.apiHit = false;
        return;
      } else {
        
        /* if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToRegister = true;
          // Reset the regError if it existed.
          this.regError = null;
          return (
            this.register({
              companyName: this.user.companyName,
              email: this.user.email,
              password: this.user.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToRegister = false;
                this.isRegisterError = false;
                this.registerSuccess = true;
                if (this.registerSuccess) {
                  this.$router.push(
                    this.$route.query.redirectFrom || {
                      name: "default",
                    }
                  );
                }
              })
              .catch((error) => {
                this.tryingToRegister = false;
                this.regError = error ? error : "";
                this.isRegisterError = true;
              })
          );
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          const { companyName, email, country, password, confirmPassword } = this.user;
          if (companyName, email, country, password, confirmPassword) {
            this.registeruser(this.user);
          } */
        //} //else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
        let formData = new FormData();
        formData.append("companyName", this.user.companyName);
        formData.append("email", this.user.email);
        formData.append("country", this.user.country.text);
        if(this.user.country.list && this.user.country.list.length > 0 && this.user.selTimezone) {
          formData.append("timezone", this.user.selTimezone.text);
        } else {
          formData.append("timezone", this.user.country.value);
        }
        formData.append("password", this.user.password);
        formData.append("total", this.user.total);
        axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/register`, formData)
          .then((res) => {
            if(res.data.success == "true") { 
              this.registerSuccess = true;
              setTimeout(() => {
                this.$router.push("/login");
                this.apiHit = false;
              }, 3000);
            } else {
              this.isRegisterError = true;
              this.regError = res.data;
              this.apiHit = false;
            }
            return res;
          })
          .catch((err) => {
            this.isRegisterError = true;
            this.regError = 'Oops ! Some error occured.';
            this.apiHit = false;
            return err;
          });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Register</h5>
                  <p>Sign up for 15 days free trial.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="@/assets/images/logo-blue.png"
                      alt
                      class="rounded-circle"
                      height="48"
                    />
                  </span>
                </div>
              </router-link>
            </div>

            <b-alert
              v-model="registerSuccess"
              class="mt-3"
              variant="success"
              dismissible
              >Registration successfull.
             </b-alert
            >

            <b-alert
              v-model="isRegisterError"
              class="mt-3"
              variant="danger"
              dismissible
              >{{ regError }}</b-alert
            >

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToRegisterIn">
              <b-form-group
              class="mb-3"
                id="company-name-group"
                label="Company Name *"
                label-for="companyName"
              >
                <b-form-input
                  id="companyName"
                  v-model="user.companyName"
                  type="text"
                  placeholder="Enter Company Name"
                  :class="{
                    'is-invalid': submitted && $v.user.companyName.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.companyName.required"
                  class="invalid-feedback"
                >
                  Company Name is required.
                </div>
              </b-form-group>

              <b-form-group class="mb-3" id="email-group" label="Email" label-for="email">
                <b-form-input
                  id="email"
                  v-model="user.email"
                  type="email"
                  placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.user.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.user.email.required">Email is required.</span>
                  <span v-if="!$v.user.email.email"
                    >Please enter valid email.</span
                  >
                </div>
              </b-form-group>

              <b-form-group
              class="mb-3"
                id="country-group"
                label="Country"
                label-for="country"
              >
              <multiselect
                v-model="user.country"
                :options="countryOptions"
                :class="{
                  'is-invalid': submitted && $v.user.country.$error,
                }"
                @input="onSelect"
                :custom-label="nameWithLang"
                track-by="text"
              ></multiselect>
                <div
                  v-if="submitted && !$v.user.country.required"
                  class="invalid-feedback"
                >
                  Country is required.
                </div>
              </b-form-group>
              <b-form-group
                v-if="user.country.list && user.country.list.length > 0"
                class="mb-3"
                id="country-group"
                label="Timezone"
                label-for="timezone"
              >
              <multiselect
                v-model="user.selTimezone"
                :options="user.country.list"
                :class="{
                  'is-invalid': submitted && $v.user.selTimezone.$error,
                }"
                :custom-label="nameWithLangAndValue"
                track-by="text"
              ></multiselect>
                <div
                  v-if="submitted && !$v.user.selTimezone.required"
                  class="invalid-feedback"
                >
                  Timezone is required.
                </div>
              </b-form-group>
              <b-form-group
              class="mb-3"
                id="password-group"
                label="Total Employees"
                label-for="totalemployees"
              >
                <b-form-input
                  id="password"
                  v-model="user.total"
                  type="number"
                  placeholder="Enter Total Employees"
                  :class="{
                    'is-invalid': submitted && $v.user.total.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.total.required"
                  class="invalid-feedback"
                >
                  Invalid Company Size.
                </div>
              </b-form-group>
              <b-form-group
              class="mb-3"
                id="confirm-password-group"
                label="Password"
                label-for="password"
              >
                <b-form-input
                  id="confirm-password"
                  v-model="user.password"
                  type="password"
                  placeholder="Enter password"
                  :class="{
                    'is-invalid': submitted && $v.user.password.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>

              <b-form-group
              class="mb-3"
                id="confirm-password-group"
                label="Confirm Password"
                label-for="confirmPassword"
              >
                <b-form-input
                  id="confirmPassword"
                  v-model="user.confirmPassword"
                  type="password"
                  placeholder="Enter Confirm Password"
                  :class="{
                    'is-invalid': submitted && $v.user.confirmPassword.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.confirmPassword.required"
                  class="invalid-feedback"
                >
                  Confirm Password is required.
                </div>
                <div
                  v-if="submitted && !$v.user.confirmPassword.sameAsPassword"
                  class="invalid-feedback"
                >
                  Passwords should match.
                </div>
              </b-form-group>
                <!--<template>
                  <vue-recaptcha @verify="verified" @error="errorverified" sitekey="6LdKDAohAAAAALMKoij6ZFKd63YY2ESpH17L4pbc"></vue-recaptcha>
                </template>-->
              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  ><span v-if="!apiHit">Register</span> <b-spinner
                variant="success"
                small
                role="status"
                v-if="apiHit"
              ></b-spinner></b-button
                >
              </div>

              <!--<div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign up using</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>-->

              <div class="mt-4 text-center">
                <p class="mb-0">
                  By registering you agree to the
                  <a href="https://workrhythm.in/terms-conditions/" target="_blank" class="text-primary">Terms and Conditions</a>
                </p>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-3 text-center">
          <p>
            Already have an account ?
            <router-link
              to="/login"
              class="fw-medium text-primary"
              >Login</router-link
            >
          </p>
          <!--<p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>-->
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>